import script from "./RangeVariant.vue?vue&type=script&setup=true&lang=ts"
export * from "./RangeVariant.vue?vue&type=script&setup=true&lang=ts"

import "./RangeVariant.vue?vue&type=style&index=0&id=8bf057a4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8bf057a4"]])

export default __exports__